import { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Wordmark } from "@/components/Wordmark";

export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === "/";

  const today = useMemo(
    () =>
      new Date().toLocaleDateString("en-US", {
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric",
      }),
    [],
  );

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed top-0 inset-x-0 z-50">
      {/* Newspaper micro-bar */}
      <div className="hidden sm:block bg-brand-black text-white" data-testid="nav-microbar">
        <div className="max-w-7xl mx-auto px-6 h-7 flex items-center justify-between font-mono text-[10px] tracking-[0.24em] uppercase">
          <span className="text-white/55">The Morning Edition</span>
          <span className="flex items-center gap-2.5 text-white/55">
            <span aria-hidden="true" className="inline-block w-1.5 h-1.5 bg-brand-red" />
            {today}
          </span>
        </div>
      </div>

      {/* Main bar */}
      <div
        className={`bg-brand-paper border-b transition-colors duration-300 ${
          scrolled ? "border-brand-black shadow-soft" : "border-brand-black/15"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
          <Wordmark size="md" to="/" />
          <nav className="flex items-center gap-2 sm:gap-1 text-sm">
            <a
              href={onHome ? "#pricing" : "/#pricing"}
              className="hidden sm:inline-block px-3 py-2 font-medium text-brand-muted-strong hover:text-brand-red transition-colors"
              data-testid="nav-pricing"
            >
              Pricing
            </a>
            <Link
              to="/signup"
              className="hidden sm:inline-block px-3 py-2 font-medium text-brand-muted-strong hover:text-brand-red transition-colors"
              data-testid="nav-signin"
            >
              Sign in
            </Link>
            <Link
              to="/signup"
              className="ml-1 sm:ml-2 inline-flex items-center gap-1.5 bg-brand-black text-white px-4 sm:px-5 py-2.5 font-semibold text-sm border border-brand-black hover:bg-brand-red hover:border-brand-red transition-colors duration-200 whitespace-nowrap"
              data-testid="nav-cta"
            >
              Get started
              <span aria-hidden="true" className="-mr-0.5">
                →
              </span>
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
